module.exports = __webpack_public_path__ + "img/plate_photo_10.1bd16a51.jpg";